import { useAccount } from "Hooks/Endpoints";
import { APIEventsContext } from "Providers/APIContexts";
import React, { useEffect, useState } from "react";
import { APIEventsProps, DefaultProviderProps } from "./types";
import moment from "moment";
import {
  EventCDR,
  EventGroupListView,
  EventsFilter,
} from "callable-data-objects";
import EventRecording from "callable-data-objects/dist/models/eventGroup/EventRecording";

const APIEventsProvider = ({ children }: DefaultProviderProps) => {
  const { account, eventGroupService } = useAccount();
  const [events, setEvents] = useState<EventGroupListView[]>([]);
  const [event, setEvent] = useState<EventGroupListView>();
  const [sequence, setSequence] = useState<string | undefined>();
  const [recordings, setRecordings] = useState<EventRecording[]>([]);
  const [cdrs, setCdrs] = useState<EventCDR[]>([]);
  const [pcap, setPcap] = useState<ArrayBuffer>();
  const [loading, setLoading] = useState<boolean>(false);
  const [filter, setFilter] = useState<EventsFilter>({
    date: moment().format("YYYY-MM-DD"),
    page: 0,
    max: 20,
    sort: "DESC",
    sortField: "created",
  });

  useEffect(() => {
    if (account && filter && eventGroupService) {
      list();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, filter, event, eventGroupService]);

  async function getRecordings() {
    setLoading(true);
    const response = await eventGroupService.recordings(event?.id);
    setRecordings(response);
    setLoading(false);
  }

  async function getSequence() {
    setLoading(true);
    const response = await eventGroupService.sequence(event?.id);
    setSequence(response);
    setLoading(false);
  }

  async function getPCAP() {
    setLoading(true);
    const response = await eventGroupService.pcap(event?.id);
    setPcap(response);
    setLoading(false);
  }

  async function getCDR() {
    setLoading(true);
    const response = await eventGroupService.cdrs(event?.id);
    setCdrs(response);
    setLoading(false);
  }

  async function list() {
    setLoading(true);
    const response = await eventGroupService.filter(filter);
    setEvents(response);
    setLoading(false);
  }

  async function onFilter(payload: EventsFilter) {
    setFilter({ ...payload });
  }

  async function select(payload: EventGroupListView) {
    setEvent(payload);
  }

  async function unselect() {
    list();
    setEvent(undefined);
  }

  const props: APIEventsProps = {
    event,
    sequence,
    getSequence,
    recordings,
    getRecordings,
    cdrs,
    getCDR,
    getPCAP,
    pcap,
    events,
    filter,
    loading,
    onFilter,
    select,
    unselect,
  };

  return (
    <APIEventsContext.Provider value={props}>
      {children}
    </APIEventsContext.Provider>
  );
};

export default APIEventsProvider;
